

import { SecondaryButton } from "@/components/Buttons/SecondaryButton";
import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { useTranslations } from "next-intl";
import { useCheckEmailForm } from "./useCheckEmailForm";
import { VideoPlayerRivInner } from "@/components/VideoPlayer/VideoPlayerRivInner";

type CheckEmailContentProps = {
  email: string;
  origin: "register" | "register-invite" | "reset-password";
  cooldownRemaining: number;
};

export const CheckEmailContent: React.FC<CheckEmailContentProps> = ({
  email,
  origin,
  cooldownRemaining,
}) => {
  const t = useTranslations("checkEmail");

  const {
    timer,
    isButtonDisabled,
    isLoadingResend,
    error,
    handleResendClick,
    handleBack,
  } = useCheckEmailForm(origin, email, cooldownRemaining);

  return (
    <div className="flex flex-col items-center w-full">
      <VideoPlayerRivInner videoName="Mail" width="w-25" height="h-25" />

      <p className="body-1-regular text-center w-full mt-4">
        {origin === "reset-password"
          ? t("descriptionResetPassword")
          : t("descriptionRegister")}
        <span className="body-1-bold"> {email}</span>
        {". "}
        {t("descriptionSuffix")}
      </p>

      {error && (
        <p role="alert" className="font-error body-2-regular text-center mt-2">
          {error}
        </p>
      )}

      <div className="flex w-full gap-3 mt-6">
        <SecondaryButton size="small" text={t("back")} onClick={handleBack} width="w-full" />
        <PrimaryButton
          size="small"
          loading={isLoadingResend}
          text={
            isButtonDisabled
              ? `${t("resend")} (${timer})`
              : t("resend")
          }
          onClick={isButtonDisabled ? () => {} : handleResendClick}
          disabled={isButtonDisabled}
          width="w-full"
        />
      </div>
    </div>
  );
};
